import { render } from "./WenAn.vue?vue&type=template&id=b3413f96&scoped=true"
import script from "./WenAn.vue?vue&type=script&lang=js"
export * from "./WenAn.vue?vue&type=script&lang=js"

import "./WenAn.vue?vue&type=style&index=0&id=b3413f96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3413f96"]])

export default __exports__